import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './utils/ScrollToTop';
import SplashScreen from './components/SplashScreen';

function App() {
  const location = useLocation();
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashFinish = () => {
    setShowSplash(false);
  };

  if (showSplash) {
    return <SplashScreen onFinish={handleSplashFinish} />;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      {location.pathname !== '/' && <Navbar />}
      <div className="flex-grow">
        <Outlet />
      </div>
      {location.pathname !== '/' && <Footer />}
    </div>
  );
}

export default App;
